import { FunctionComponent, useCallback } from 'react'
import { Grid } from '@material-ui/core'
import { Li, Subtitle, Title, Ul } from '../../../../../styles'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import { useOnboarding } from 'modules/pagamentos/hooks/useOnboarding'
import ETipoDocumentoOnboarding from 'modules/pagamentos/domain/entities/ETipoDocumentoOnboarding'
import ButtonFile from 'shared/components/ButtonFile'

interface FundoDeInvestimentoProps {
  empresaControladora?: boolean
}
const FundoDeInvestimento: FunctionComponent<FundoDeInvestimentoProps> = ({
  empresaControladora,
}) => {
  const { frotistaId } = useFrotista()
  const {
    getDocumentoNome,
    addDocumento,
    documentos,
    addDocumentoEmpresaControladora,
    documentosEmpresaControladora,
    getDocumentoEmpresaControladoraNome,
  } = useOnboarding()

  const handleSelectFile = useCallback(
    (file: File, fileName: string, tipo: ETipoDocumentoOnboarding) => {
      addDocumento({
        arquivo: file,
        tipo,
        frotista_id: frotistaId,
      })
    },
    [documentos],
  )

  const handleSelectFileEmpresaControladora = useCallback(
    (file: File, fileName: string, tipo: ETipoDocumentoOnboarding) => {
      addDocumentoEmpresaControladora({
        arquivo: file,
        tipo,
        frotista_id: frotistaId,
      })
    },
    [documentosEmpresaControladora],
  )
  return (
    <Grid item xs={12} sm={12} md={12} lg={12}>
      <Title>Estatuto Social</Title>
      <Subtitle>
        Envie o Estatuto Social seguindo as dicas abaixo:
        <Ul>
          <Li>
            Envie a última atualização, consolidada com todas as alterações já
            realizadas anteriormente
          </Li>
          <Li>
            {' '}
            Todas as páginas do documento devem estar em um único arquivo PDF
          </Li>
          <Li>
            O documento deve estar registrado no órgão de registro competente
            (Junta Comercial, Cartório ou OAB)
          </Li>
        </Ul>
      </Subtitle>
      <ButtonFile
        id="estatutoSocial"
        label="Anexar documento*"
        onSelectFile={(file: File, fileName: string) =>
          empresaControladora
            ? handleSelectFileEmpresaControladora(
                file,
                fileName,
                ETipoDocumentoOnboarding.ESTATUTO_SOCIAL,
              )
            : handleSelectFile(
                file,
                fileName,
                ETipoDocumentoOnboarding.ESTATUTO_SOCIAL,
              )
        }
        file={
          empresaControladora
            ? getDocumentoEmpresaControladoraNome(
                ETipoDocumentoOnboarding.ESTATUTO_SOCIAL,
              )
            : getDocumentoNome(ETipoDocumentoOnboarding.ESTATUTO_SOCIAL)
        }
        accept={'.pdf'}
      />
      <ButtonFile
        id="estatutoSocial"
        label="Anexar documento"
        onSelectFile={(file: File, fileName: string) =>
          empresaControladora
            ? handleSelectFileEmpresaControladora(
                file,
                fileName,
                ETipoDocumentoOnboarding.ESTATUTO_SOCIAL,
              )
            : handleSelectFile(
                file,
                fileName,
                ETipoDocumentoOnboarding.ESTATUTO_SOCIAL,
              )
        }
        file={
          empresaControladora
            ? getDocumentoEmpresaControladoraNome(
                ETipoDocumentoOnboarding.ESTATUTO_SOCIAL,
              )
            : getDocumentoNome(ETipoDocumentoOnboarding.ESTATUTO_SOCIAL)
        }
        accept={'.pdf'}
      />
    </Grid>
  )
}

export default FundoDeInvestimento
